// http://{{twzb-url}}/srv/activityDeleteRecord/list?pageNum=1&pageSize=10

import { httpCreate } from './http';

const http = httpCreate('/srv/activityDeleteRecord');

export const activityDeleteRecord = {
	getList(params) {
		return http.get('/list', { params });
	},
};
